<template>
    <footer class="footer"
            :class="{[`footer-${type}`]: type}"
            :data-background-color="backgroundColor">
        <div class="container">
            <nav>
                <ul>
                </ul>
            </nav>
            <div class="copyright">
                &copy; {{year}} <a href="https://electronictechcorp.com" target="_blank">Electronic Technologies Corp.</a>
            </div>
            <div style="display:none;">
                <img src="img/monitor-gif.gif" width="1" height="1" border="0" alt="1"/>
            </div>


        </div>
    </footer>
</template>
<script>
  export default {
    props: {
      backgroundColor: String,
      type: String
    },
    data(){
      return {
        year: new Date().getFullYear()
      }
    }
  }
</script>
<style>
</style>
